interface LensSource {
  sku: string;
  path: string;
}
let source: LensSource | null = null;

export function rememberLensSource(sku: string) {
  source = { sku, path: window.location.pathname + window.location.search + window.location.hash };
}

export function consumeLensSource(sku: string): LensSource | null {
  const current = source?.sku === sku ? source : null;
  source = null;
  return current;
}

/** 替换已完成流程的当前历史项，不先挂载购物车；保留 App Router 自己的 state。 */
export function replaceCompletedLensHistory() {
  window.history.replaceState(window.history.state, '', '/cart?from=payment');
}
